import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Order } from "src/app/shared/models/order.model";

class TrackerStep {
  stepId: number;
  text: string;
}

@Component({
  selector: "order-tracker",
  templateUrl: "./order-tracker.component.html",
  styleUrls: ["./order-tracker.component.scss"],
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class OrderTrackerComponent implements OnInit {
  @Input() order: Order;

  steps: TrackerStep[] = [];

  get isOnHold() {
    return this.order.orderTrackerGroup == "ON_HOLD";
  }

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    for (let index = 1; index <= 5; index++) {
      this.steps.push({
        stepId: index,
        text: this.translateService.instant("translate.tracker.step" + 1),
      });
    }
  }

  isCur(step: TrackerStep): boolean {
    switch (this.order.orderTrackerGroup) {
      case "RECEIVED":
        return step.stepId == 1;
      case "PRODUCTION":
        return step.stepId == 2;
      case "IN_AIR":
        return step.stepId == 3;
      case "QC":
        return step.stepId == 4;
      case "DISTRIBUTION":
        return false; //step.stepId == 5;
      default:
        false;
    }
  }

  isPast(step: TrackerStep): boolean {
    switch (this.order.orderTrackerGroup) {
      case "RECEIVED":
        return false;
      case "PRODUCTION":
        return step.stepId < 2;
      case "IN_AIR":
        return step.stepId < 3;
      case "QC":
        return step.stepId < 4;
      case "DISTRIBUTION":
        return true; //step.stepId < 5;
      default:
        false;
    }
  }

  isFuture(step: TrackerStep): boolean {
    if (this.order.orderTrackerGroup == null) return true;

    switch (this.order.orderTrackerGroup) {
      case "RECEIVED":
        return step.stepId > 1;
      case "PRODUCTION":
        return step.stepId > 2;
      case "IN_AIR":
        return step.stepId > 3;
      case "QC":
        return step.stepId > 4;
      case "DISTRIBUTION":
        return false;
      default:
        false;
    }
  }

  getIcon(step: TrackerStep) {
    var icon = "assets\\img\\tracker\\step" + step.stepId + "_";
    var color = "grey";
    if (this.isCur(step)) {
      color = "blue";
    } else if (this.isPast(step)) {
      color = "white";
    }
    icon += color + ".svg";
    return icon;
  }

  getStepDescr(step: TrackerStep) {
    return this.translateService.instant(
      "translate.tracker.step" + step.stepId
    );
  }
}
